import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import * as RefundRulesUC from '../../../usecases/refundRules/RefundRulesUC';
import FeatureService from '../../../services/feature/FeatureService';
import Features from '../../../const/Features';
import I18n from 'i18n-react';
import Moment from 'moment';
import './RefundRulesDetail.css';
import ErrorModal from '../../common/errorModal/ErrorModal';
import BestPriceModal from '../../common/bestPriceModal/BestPriceModal';
import Listener from '../../../const/Listener';
import EventEmitter from '../../modules/event-emitter/EventEmitter';
import ExchangeService from '../../../services/exchange/ExchangeService';
import { cloneDeep, set } from 'lodash';
import axios from 'axios';
import _ from 'lodash';
import RefundType from '../../../const/RefundType';
import TicketChangeType from '../../../const/TicketChangeType';

const propTypes = {
  passengers: PropTypes.shape({
    adultNumber: PropTypes.number.isRequired,
    childNumber: PropTypes.number.isRequired,
    infantNumber: PropTypes.number.isRequired
  }).isRequired,
  callbackSetRefundRule: PropTypes.func,
  callbackDeleteFlights: PropTypes.func,
  callbackHome: PropTypes.func,
  departureFlight: PropTypes.shape({}).isRequired,
  returnFlight: PropTypes.shape({})
};

const defaultProps = { returnFlight: null };

class RefundRulesDetail extends React.Component {
  constructor() {
    super();

    this.state = {
      refundRules: null,
      featureCurrencyConverter: null,
      refundRulesErro: false,
      messageInfo: null,
      openModal: false,
      showBestPrice: false,
      totalValueVoo: null,
      totalPointsVoo: null,
      totalPassengers: null,
      quotationJourney: null,
      showPrices: false,
      totalValueAdult: null,
      totalPointAdultDeparture: null,
      totalPointAdultReturn: null,
      totalValueChild: null,
      totalPointChildDeparture: null,
      totalPointChildReturn: null,
      totalValueInfant: null,
      totalPointInfantDeparture: null,
      totalPointInfantReturn: null,
      totalTax: null
    };

    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.redirectModal = this.redirectModal.bind(this);
    this.homeModal = this.homeModal.bind(this);
    this.reCalculate = this.reCalculate.bind(this);
    this.renderInfBestPrice = this.renderInfBestPrice.bind(this);
  }

  componentWillMount() {
    RefundRulesUC.execute(
      this.props.departureFlight,
      this.props.returnFlight,
      this.props.passengers
    ).then(refundRules => {
      if (refundRules.error) {
        this.setState({
          refundRulesErro: true
        });        
        const erro = refundRules.error.response &&  refundRules.error.response.data ? <p>{refundRules.error.response.data.reason}</p> : <p>{I18n.translate('components.refundRulesDetail.error')}</p>;
        this.showModal(erro);
      } else {
       if ((refundRules.departureFlightBestPrice) && (refundRules.feeBestPrice.total.value !== this.getValueTxAtual())) {
         this.changePropsBestPrice(refundRules);
       } else {
          this.setState({
            refundRules: refundRules
          });
        }
        this.props.callbackSetRefundRule(refundRules);

      }
    });
    FeatureService.isFeatureEnabled(Features.CURRENCY_CONVERTER).then(isEnabled => {
      this.setState({
        featureCurrencyConverter: isEnabled
      });
    });
  }

  getValueTxAtual() {
    let retorno;
    if (this.props.returnFlight) {
      let fee = this.props.returnFlight.flight.fee;
      if (fee.economy.total)
        retorno = fee.economy.total.value;
      else if (fee.business.total)
        retorno = fee.business.total.value;

    } else {
      retorno = this.props.departureFlight.flight.recommendations[0].fee.total.value;
    }
    return retorno;
  }

  showModal(message) {
    this.setState({
      openModal: true,
      messageInfo: message
    });
  }

  closeModal() {
    this.setState({
      openModal: false,
      messageInfo: ''
    });
  }

  homeModal() {
    this.props.callbackHome();
  }

  redirectModal() {
    this.props.callbackDeleteFlights(this.props.departureFlight, this.props.returnFlight);
  }

  getValueFormatted(value) {
    return value
      .toFixed(2)
      .replace('.', ',')
      .replace(/(\d)(?=(\d{3})+,)/g, '$1.');
  }

  getPointsFormatted(value) {
    const pattern = /\B(?=(\d{3})+(?!\d))/g;
    return value.toString().replace(pattern, '.');
  }

  renderLoading() {
    return (
      <div className="Spinner" data-unit="loadingSpinner">
        <div>
          <i className="icon-spinner" />
        </div>
      </div>
    );
  }

  renderModalError() {
    return (
      <ErrorModal
        id="modalRefundRulesDetailsError"
        message={this.state.messageInfo}
        showModal={this.state.openModal}
        firstOption={this.redirectModal}
        secondOption={this.homeModal}
        firstButtonModal="Selecionar outro Voo"
        ref={c => {
          this.modalRefundRulesDetailsError = c;
        }}
      />
    );
  }

  renderModalBestPrice() {
    const { showBestPrice } = this.state;
    return (
      <BestPriceModal
        id="modalBestPrice"
        message={this.renderInfBestPrice()}
        showModal={showBestPrice}
        firstOption={this.redirectModal}
        secondOption={this.reCalculate}
        firstButtonModal="Refazer Busca"
        ref={c => {
          this.modalBestPrice = c;
        }}
      />
    );
  }
  reCalculate() {
    this.setFeeAndPointsBestPrice(this.state.refundRules);
    this.setState({
      showBestPrice: false
    });
  }

  changePropsBestPrice(refundRules) {
    let totalValueAdult = refundRules.pricesBestPrice == null ? 0 : refundRules.pricesBestPrice
      .filter(item => item.passenger === "ADULT").reduce((a, b) => a + b.value, 0);
    let totalValueChild = refundRules.pricesBestPrice == null ? 0 : refundRules.pricesBestPrice
      .filter(item => item.passenger === "CHILD").reduce((a, b) => a + b.value, 0);
    let totalValueInfant = refundRules.pricesBestPrice == null ? 0 : refundRules.pricesBestPrice
      .filter(item => item.passenger === "INFANT").reduce((a, b) => a + b.value, 0);

    if (this.props.returnFlight) {
      axios.all([this.getPointByTypePassengerType(totalValueAdult / 2, "ADULT"),
      this.getPointByTypePassengerType(totalValueChild / 2, "CHILD"),
      this.getPointByTypePassengerType(totalValueInfant / 2, "INFANT")]).then(
        axios.spread(function (pointsAdult, pointsChild, pointsInfant) {
          this.setState({
            totalValueAdult: totalValueAdult, totalPointAdultDeparture: pointsAdult, totalPointAdultReturn: pointsAdult,
            totalValueChild: totalValueChild, totalPointChildDeparture: pointsChild, totalPointChildReturn: pointsChild,
            totalValueInfant: totalValueInfant, totalPointInfantDeparture: pointsInfant, totalPointInfantReturn: pointsInfant
          });
          if (!this.state.refundRulesErro)
            this.setAtributesAndShowModal(refundRules);
        }.bind(this))
      )
    } else {
      axios.all([this.getPointByTypePassengerType(totalValueAdult, "ADULT"),
      this.getPointByTypePassengerType(totalValueChild, "CHILD"),
      this.getPointByTypePassengerType(totalValueInfant, "INFANT")]).then(
        axios.spread(function (pointsAdult, pointsChild, pointsInfant) {
          this.setState({
            totalValueAdult: totalValueAdult, totalPointAdultDeparture: pointsAdult, totalPointAdultReturn: 0,
            totalValueChild: totalValueChild, totalPointChildDeparture: pointsChild, totalPointChildReturn: 0,
            totalValueInfant: totalValueInfant, totalPointInfantDeparture: pointsInfant, totalPointInfantReturn: 0
          });
          if (!this.state.refundRulesErro)
            this.setAtributesAndShowModal(refundRules);

        }.bind(this))
      )

    }
  }

  setAtributesAndShowModal(refundRules) {
    let totalValueVoo = this.state.totalValueAdult + this.state.totalValueChild + this.state.totalValueInfant;
    let qtdAdultNumber = this.props.passengers.adultNumber == null ? 0 : this.props.passengers.adultNumber;
    let qtdChildNumber = this.props.passengers.childNumber == null ? 0 : this.props.passengers.childNumber;
    let qtdInfantNumber = this.props.passengers.infantNumber == null ? 0 : this.props.passengers.infantNumber;
    let totalPassengers = qtdAdultNumber + qtdChildNumber + qtdInfantNumber;
    let tax = refundRules.feeBestPrice.total.value;
    let totalPointsVoo = Number((this.state.totalPointAdultDeparture * qtdAdultNumber) + (this.state.totalPointAdultReturn * qtdAdultNumber) + (this.state.totalPointChildDeparture * qtdChildNumber) +
      (this.state.totalPointChildReturn * qtdChildNumber) + (this.state.totalPointInfantDeparture * qtdInfantNumber) + (this.state.totalPointInfantReturn * qtdInfantNumber));

    this.setState({
      refundRules: refundRules, showBestPrice: refundRules.departureFlightBestPrice != null,
      totalValueVoo: totalValueVoo, totalPointsVoo: totalPointsVoo, totalPassengers: totalPassengers, totalTax: tax
    });


    if (this.props.returnFlight) {
      this.props.departureFlight.value = Number(this.state.totalPointAdultDeparture);
      this.props.returnFlight.value = Number(this.state.totalPointAdultReturn);
      if (this.state.totalPointChildDeparture > 0) {
        this.props.departureFlight.childValue = Number(this.state.totalPointChildDeparture);
        this.props.returnFlight.childValue = Number(this.state.totalPointChildReturn);
      }
      if (this.state.totalPointInfantDeparture > 0) {
        this.props.departureFlight.infantValue = Number(this.state.totalPointInfantDeparture);
        this.props.returnFlight.infantValue = Number(this.state.totalPointInfantReturn);
      }
    } else {
      this.props.departureFlight.value = Number(this.state.totalPointAdultDeparture);
      if (this.state.totalPointChildDeparture > 0) {
        this.props.departureFlight.childValue = Number(this.state.totalPointChildDeparture);
      }
      if (this.state.totalPointInfantDeparture > 0) {
        this.props.departureFlight.infantValue = Number(this.state.totalPointInfantDeparture);
      }
    }
  }

  getPointByTypePassengerType(totalValue, passengerType) {
    if (totalValue > 0) {
      return this.getPoints(this.props, totalValue, passengerType).then(({ isAvailable, points }) => {
        if (isAvailable) {
          return points.value;
        } else {
          this.setState({
            refundRulesErro: true
          });
          const erro = <p>{I18n.translate('components.refundRulesDetail.erroPointsBestPrice')}</p>;
          this.showModal(erro)
        }
      });
    } else {
      return 0;
    }
  }

  setFeeAndPointsBestPrice(refundRules) {
    this.setObjectBooking(refundRules);
    let propstotal = cloneDeep(this.props);
    if (propstotal.returnFlight) {
      propstotal.departureFlight.value = Number(this.state.totalPointAdultDeparture);
      propstotal.returnFlight.value = Number(this.state.totalPointAdultReturn);
    } else {
      propstotal.departureFlight.value = Number(this.state.totalPointAdultDeparture);
    }
    let quote = {
      departureFlight: propstotal.departureFlight,
      returnFlight: propstotal.returnFlight,
      finalDestination: propstotal.departureFlight.flight.originAirport,
      origin: propstotal.departureFlight.flight.finalDestination,
      passengers: propstotal.passengers
    }
    quote.departureFlight.flight.flightGroup.forEach(function (flightGroup, inc) {
      flightGroup = Object.assign(flightGroup, {
        classOfService: refundRules.departureFlightBestPrice.flightGroup[inc].classOfService,
        flightNumber: refundRules.departureFlightBestPrice.flightGroup[inc].flightNumber,
        fareBasis: refundRules.departureFlightBestPrice.flightGroup[inc].fareBasis,
        cabinCategory : refundRules.departureFlightBestPrice.flightGroup[inc].cabinCategory
      });
    });

    quote.departureFlight.flight.prices.forEach(function (price, inc) {
      let valor = price.passenger == "ADULT" ? this.state.totalValueAdult : price.passenger == "CHILD" ?
        this.state.totalValueChild : price.passenger == "INFANT" ? this.state.totalValueInfant : 0;
      if (price.currency == "BRL") {
        price = Object.assign(price, {
          value: valor
        });
      }
    }.bind(this));

    if (propstotal.returnFlight) {
      quote.returnFlight.flight.flightGroup.forEach(function (flightGroup, inc) {
        flightGroup = Object.assign(flightGroup, {
          classOfService: refundRules.returnFlightBestPrice.flightGroup[inc].classOfService,
          flightNumber: refundRules.returnFlightBestPrice.flightGroup[inc].flightNumber,
          fareBasis: refundRules.returnFlightBestPrice.flightGroup[inc].fareBasis,
          cabinCategory : refundRules.returnFlightBestPrice.flightGroup[inc].cabinCategory
        });

      });

      quote.returnFlight.flight.prices.forEach(function (price, inc) {
        let valor = price.passenger == "ADULT" ? this.state.totalValueAdult : price.passenger == "CHILD" ?
          this.state.totalValueChild : price.passenger == "INFANT" ? this.state.totalValueInfant : 0;
        if (price.currency == "BRL") {
          price = Object.assign(price, {
            value: valor
          });
        }
      }.bind(this));


    }


    this.setState({ quotationJourney: quote, showPrices: false });
    EventEmitter.emitEvent(Listener.CLEAR_OVERVIEW_LISTENER);
    EventEmitter.emitEvent(Listener.CALCULATE_POINTS_LISTENER, quote);
  }

  setObjectBooking(refundRules) {
    if (this.props.returnFlight) {

      let economy = {
        total: {
          value: refundRules.feeBestPrice.total.value,
          currency: refundRules.feeBestPrice.total.currency
        }
      };
      let business = {};
      if (this.props.returnFlight.category.toLowerCase() === 'business') {
        business = {
          total: {
            value: refundRules.feeBestPrice.total.value,
            currency: refundRules.feeBestPrice.total.currency
          }
        };
      }
      const fee = Object.assign({}, fee, {
        economy: economy,
        business: business
      });
      this.props.returnFlight.flight.fee = fee;
      let fare;
      if (this.props.returnFlight.category.toLowerCase() === 'business') {
        var objectFareTypes = _.first(_.toArray(this.props.returnFlight.flight.fare.business.departure));
        let businessFare = {};
        let departureBusiness = {};
        refundRules.departureFlightBestPrice.flightGroup.forEach(element => {
          let numberVoo = element.flightNumber;
          Object.assign(departureBusiness, {
            [numberVoo]: {
              classOfService: element.classOfService,
              fareBasis: element.fareBasis,
              fareTypes: objectFareTypes.fareTypes
            }
          });
        });
        let returnBusiness = {};
        refundRules.returnFlightBestPrice.flightGroup.forEach(element => {
          let numberVoo = element.flightNumber;
          Object.assign(returnBusiness, {
            [numberVoo]: {
              classOfService: element.classOfService,
              fareBasis: element.fareBasis,
              fareTypes: objectFareTypes.fareTypes
            }
          });
        });
        Object.assign(businessFare, {
          departure: departureBusiness,
          return: returnBusiness
        });

        fare = Object.assign({}, fare, {
          economy: {},
          business: businessFare
        });


      } else {
        let economyFare = {};
        let departureEconomy = {};
        let objectFareTypes = _.first(_.toArray(this.props.returnFlight.flight.fare.economy.departure));
        refundRules.departureFlightBestPrice.flightGroup.forEach(element => {
          let numberVoo = element.flightNumber;
          Object.assign(departureEconomy, {
            [numberVoo]: {
              classOfService: element.classOfService,
              fareBasis: element.fareBasis,
              fareTypes: objectFareTypes.fareTypes
            }
          });
        });
        let returnEconomy = {};
        refundRules.returnFlightBestPrice.flightGroup.forEach(element => {
          let numberVoo = element.flightNumber;
          Object.assign(returnEconomy, {
            [numberVoo]: {
              classOfService: element.classOfService,
              fareBasis: element.fareBasis,
              fareTypes: objectFareTypes.fareTypes
            }
          });
        });
        Object.assign(economyFare, {
          departure: departureEconomy,
          return: returnEconomy
        });

        fare = Object.assign({}, fare, {
          economy: economyFare,
          business: {}
        });
      }
      this.props.returnFlight.flight.fare = fare;
    } else {
      let recommendations = [];
      let objectFareTypes = _.first(_.toArray(this.props.departureFlight.flight.recommendations[0].fare));
      let Objectrecommendation = {
        departureCategory: this.props.departureFlight.category,
        validateCompany: this.props.departureFlight.flight.recommendations[0].validateCompany,
        fee: {
          total: {
            value: refundRules.feeBestPrice.total.value,
            currency: refundRules.feeBestPrice.total.currency
          }
        }
      };

      let fare = {};
      refundRules.departureFlightBestPrice.flightGroup.forEach(element => {
        let numberVoo = element.flightNumber;
        Object.assign(fare, {
          [numberVoo]: {
            classOfService: element.classOfService,
            fareBasis: element.fareBasis,
            fareTypes: objectFareTypes.fareTypes
          }
        });
      });
      Object.assign(Objectrecommendation, {
        fare: fare
      });
      recommendations.push(Objectrecommendation);
      this.props.departureFlight.flight.recommendations = recommendations;
    }
  }


  getPoints(props, price, passengerType) {
    let items = {
      departureFlightAirport: props.departureFlight.flight.finalDestination,
      arrivalFlightAirport: props.departureFlight.flight.originAirport,
      departureFlightDate: props.departureFlight.flight.departureDate,
      departureFlightTime: props.departureFlight.flight.departureTime,
      cabin: props.departureFlight.category.toUpperCase(),
      operatingCarriers: props.departureFlight.flight.operatingCarriers
    };
    let priceObject = {
      value: price,
      passenger: passengerType,
      currency: "BRL"
    };
    const payload = Object.assign({}, items, {
      value: priceObject.value,
      currency: priceObject.currency,
      classType: props.departureFlight.flight.fareOriginType,
      passengerType: priceObject.passenger
    });

    if (payload.classType === 'AWARD') {
      let partner = []
      partner.push(this.assemblerPartnerWhenAward(props.departureFlight));
      partner != null ? payload.operatingCarriers = partner : null;
    }


    if (payload.classType === 'AWARD') {
      let partner = []
      partner.push(this.assemblerPartnerWhenAward(props.departureFlight));
      partner != null ? payload.operatingCarriers = partner : null;
    }

    return ExchangeService.getPoints(payload);
  }

  assemblerPartnerWhenAward(flight) {
    let partner = null;
    
    if (flight.flight.recommendations == null) {
      let fare = flight.fare;
      let fareBasis = this.getFareBasisFromFare(fare);
    
      partner = this.extractPartner(fareBasis);
    } else {
      let fare = flight.flight.recommendations[0].returnFlights[0].categories[0].fare.departure;
      let firstFareKey = Object.keys(fare)[0];
      let fareBasis = fare[firstFareKey].fareBasis;

      partner = this.extractPartner(fareBasis);
    }

    return partner;
  }
  
  extractPartner(fareBasis) {
    const parts = fareBasis.split("");
    if (fareBasis.includes("AWARD") && parts.length >= 3) {
      return parts[1] + parts[2];
    } else if (fareBasis.includes("P00") && parts.length >= 2) {
      const lastTwoElements = parts[parts.length - 2] + parts[parts.length - 1];
      if (lastTwoElements === "EK") {
        return lastTwoElements;
      }
    }
    return null;
  }

  getFareBasisFromFare(fare) {
    let fareWithCabinKey = Object.keys(fare).find(key => key !== '');
    let fareWithCabin = fare[fareWithCabinKey];
    let getDeparture = Object.keys(fareWithCabin)[0];
    let fareWithDeparture = fareWithCabin[getDeparture];
    let firstFare = Object.keys(fareWithDeparture)[0];
    return fareWithDeparture[firstFare].fareBasis;
  }

  renderInfBestPrice() {
    return (
      <div>
        <Row>
          <Col className="modal-bestPrice-titleMsg">
            <span>{I18n.translate('components.refundRulesDetail.msgBestPrice')}</span>
          </Col>
        </Row>
        <Row>
          <Col className="modal-bestPrice-titleMsgBlack">
            <span>{I18n.translate('components.refundRulesDetail.msgBestPrice2')}</span><br></br>

            <span className="modal-bestPrice-titleMsgBlackAndNegrito">{this.getPointsFormatted(Number(this.state.totalPointsVoo / this.state.totalPassengers).toFixed(0)) + ' Pontos e R$ ' + this.getValueFormatted(this.state.totalTax / this.state.totalPassengers) + ' Por Passageiro'}</span>
          </Col>
        </Row>
        <Row>
          <Col className="modal-bestPrice-titleMsgBlack">
            <span>{' Novo Valor Total para ' + this.state.totalPassengers + ' Passageiro(s)'}</span><br></br>
            <span className="modal-bestPrice-textTotalPointeValue">{this.getPointsFormatted(this.state.totalPointsVoo) + ' Pontos e R$ ' + this.getValueFormatted(this.state.totalTax)}</span>
          </Col>
        </Row>
      </div >
    )
  }

  renderValueTicketChange(passengerInfo){
    if(passengerInfo.totalValueTicketChange != 0){  
      return(
        <span>
          <span className="RefundRulesDetail__taxes--currencyCode">
                    {I18n.translate('components.refundRulesDetail.currencyBRL')}
          </span>
          <span className="RefundRulesDetail__taxes--valueByPaxType">
          {I18n.translate('components.refundRulesDetail.currencyValue', {
                  value: this.getValueFormatted(passengerInfo.totalValueTicketChange)
                  })}
          </span>
        </span>
      )
    }else{
      return(
      <span>
        {I18n.translate('components.refundRulesDetail.changeMessage')} 
      </span>
      )
    }
  }


  renderPassengerRufundByType(passengerInfo, index) {
    return (
      <Row
        key={index}
        className="RefundRulesDetail__taxes"
        data-test={`passengerRefundInfo-${index}`}>
        <Col
          xs={6}
          className="RefundRulesDetail__taxes--passangerQuantity"
          data-unit="passengerRefundInfo">
          <div>
            <span data-test="passengerQtd">
              {I18n.translate('components.refundRulesDetail.pax', {
                context: passengerInfo.quantity
              })}
            </span>{' '}
            <span data-test="passengerType" className="RefundRulesDetail__taxes--passangerType">
              {I18n.translate(`components.refundRulesDetail.${passengerInfo.passengerType}`, {
                context: passengerInfo.quantity
              })}
            </span>
          </div>
        </Col>
        <Col
          xs={3}
          data-unit="refundableValue"
          className="RefundRulesDetail__taxes--valueAlignment">
          {passengerInfo.ticketChange ===  TicketChangeType.IS_ALLOWED ? (
            <div data-test="passengerRefundValue">
              {this.renderValueTicketChange(passengerInfo)}
            </div>
          ) : (
            <div data-test="passengerRefundValue">
              <span className="RefundRulesDetail__value--notRefundableValue">               
                {I18n.translate(`components.refundRulesDetail.${passengerInfo.ticketChange}`)}
              </span>
            </div>
          )}
        </Col>
        <Col
          xs={3}
          data-unit="refundableValue"
          className="RefundRulesDetail__taxes--valueAlignment">
          {passengerInfo.refundType ===  RefundType.REFUNDABLE ? (
            <div data-test="passengerRefundValue">
              <span className="RefundRulesDetail__taxes--currencyCode">
                {I18n.translate('components.refundRulesDetail.currencyBRL')}
              </span>{' '}
              <span className="RefundRulesDetail__taxes--valueByPaxType">
                {I18n.translate('components.refundRulesDetail.currencyValue', {
                  value: this.getValueFormatted(passengerInfo.totalValue)
                })}
              </span>
            </div>
          ) : (
            <div data-test="passengerRefundValue">
              <span className="RefundRulesDetail__value--notRefundableValue">
                {I18n.translate(`components.refundRulesDetail.${passengerInfo.refundType}`)}
              </span>
            </div>
          )}
        </Col>
      </Row>
    );
  }

  renderRefundInfo() {
    const { passengerInfo, totalAmount, exchangeRate, totalAmountTicketChange} = this.state.refundRules;
    let ticketChangeMessage = null;
    let cancelTaxInfoMessage = null;
    if (this.state.featureCurrencyConverter) {
        let index = passengerInfo.findIndex(type => type.passengerType === "ADULT");
        if (passengerInfo[index].ticketChange === TicketChangeType.IS_ALLOWED) {
          ticketChangeMessage = I18n.translate('components.refundRulesDetail.ticketChange')
      } 
      cancelTaxInfoMessage = I18n.translate(
        'components.refundRulesDetail.CancelTaxInformationMessageWithCurrency',
        {
          currency: exchangeRate ? ` (R$ ${this.getValueFormatted(exchangeRate)})` : ''
        }
      );
    } else {
      cancelTaxInfoMessage = I18n.translate(
        'components.refundRulesDetail.CancelTaxInformationMessage',
        {
          date: Moment().format('DD/MM/YYYY')
        }
      );
    }

    return (
      <div className="RefundRulesDetail">
        <Row>
          <Col xs={5} className="RefundRulesDetail__title--paxTax" data-unit="labelPaxTax">
            <span>{I18n.translate('components.refundRulesDetail.paxTax')}</span>
          </Col>
          <Col xs={2} />
          <Col xs={2} className="RefundRulesDetail__title--cancelTax" data-unit="labelCancelTax">
            <span>{I18n.translate('components.refundRulesDetail.editTax')}</span>
          </Col>
          <Col xs={3} className="RefundRulesDetail__title--cancelTax" data-unit="labelCancelTax">
            <span>{I18n.translate('components.refundRulesDetail.cancelTax')}</span>
          </Col>
        </Row>
        {passengerInfo.map((passengerInfo, index) => {
          return this.renderPassengerRufundByType(passengerInfo, index);
        })}
        <div className="RefundRulesDetail__hr" />
        <Row>
          <Col
            xs={6}
            className="RefundRulesDetail__title--totalCancelTax"
            data-unit="labelTotalCancelTax">
            <span>{I18n.translate('')}</span>
          </Col>
          {totalAmountTicketChange && totalAmountTicketChange>0 ? (
            <Col
              xs={3}
              className="RefundRulesDetail__value--totalCancelTax"
              data-test="refundInfoTotalAmount"
              data-unit="totalAmount">
              <span className="RefundRulesDetail__value--totalByType">
               {I18n.translate('components.refundRulesDetail.total')}
              </span>
              <span className="RefundRulesDetail__value--currencyCode">
               {I18n.translate('components.refundRulesDetail.currencyBRL')}
              </span>{' '}
              <span>
                {I18n.translate('components.refundRulesDetail.currencyValue', {
                value: this.getValueFormatted(totalAmountTicketChange)
               })}
              </span>
             </Col>
            ) : (
             <Col
               xs={3}
               className="RefundRulesDetail__value--totalCancelTax"
               data-test="refundInfoTotalAmount"
               data-unit="totalAmount">            
              </Col>
            )}
           {totalAmount && totalAmount>0 ? (
             <Col
               xs={3}
               className="RefundRulesDetail__value--totalCancelTax"
               data-test="refundInfoTotalAmount"
               data-unit="totalAmount">
               <span className="RefundRulesDetail__value--totalByType">
                {I18n.translate('components.refundRulesDetail.total')}
               </span>
               <span className="RefundRulesDetail__value--currencyCode">
                 {I18n.translate('components.refundRulesDetail.currencyBRL')}
               </span>{' '}
               <span>
                 {I18n.translate('components.refundRulesDetail.currencyValue', {
                 value: this.getValueFormatted(totalAmount)
                })}
               </span>
             </Col>
            ) : (
             <Col
               xs={3}
               className="RefundRulesDetail__value--totalCancelTax"
               data-test="refundInfoTotalAmount"
               data-unit="totalAmount">            
             </Col>
            )}
        </Row>
        <Row>
          <Col xs={12}>
          <p
              className="RefundRulesDetail__title--cotation"
              >
              <strong>{ticketChangeMessage}</strong>
            </p>
            <span
              className="RefundRulesDetail__title--cotation"
              data-unit="labelCancelTaxInformationMessage"
              data-test="labelCancelTaxInformationMessage">
              {cancelTaxInfoMessage}
            </span>
          </Col>
        </Row>
      </div>
    );
  }
  renderNotRefundable() {
    return (
      <div className="RefundRulesDetail">
        <Row
          className="RefundRulesDetail__title--notRefundable"
          data-test="labelNotRefundableTax"
          data-unit="labelNotRefundableTax">
          <span>{I18n.translate('components.refundRulesDetail.NotRefundableTax')}</span>
        </Row>
      </div>
    );
  }
  render() {
    const { refundRules, featureCurrencyConverter, refundRulesErro, showBestPrice } = this.state;
    let renderReturn;

    if (showBestPrice) {
      renderReturn = this.renderModalBestPrice();
    } else if (refundRulesErro) {
      renderReturn = this.renderModalError();
    } else if (!refundRules || featureCurrencyConverter == null) {
      renderReturn = this.renderLoading();
    } else {
      renderReturn = this.renderRefundInfo();
    }

    return renderReturn;
  }
}

RefundRulesDetail.propTypes = propTypes;
RefundRulesDetail.defaultProps = defaultProps;

export default RefundRulesDetail;



// WEBPACK FOOTER //
// ./src/components/flightSelection/refundRulesDetail/RefundRulesDetail.jsx